import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'
import backgroundImage from '../../assets/maker-viewer.jpg'
import { COLOR_BLACK, COLOR_WHITE } from '../../lib/colors'
import UILogo from '../../components/UI/UILogo'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    width: '40%',
    position: 'relative',
    backgroundColor: COLOR_BLACK,
    '@media (max-width: 480px)': {
      position: 'relative',
      margin: '0',
      padding: '0',
      top: '0',
    },
  },
  backgroundImage: {
    objectFit: 'cover',
    width: '100%',
    '@media (max-width: 480px)': {
      height: '100%',
      position: 'absolute',
      top: '0',
      left: '0',
    },
  },
  content: {
    position: 'absolute',
    zIndex: 2,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 700,
    color: COLOR_WHITE,
    letterSpacing: '-0.05em',
    '@media (max-width: 480px)': {
      position: 'relative',
    },
  },
  title: {
    fontSize: '11em',
    marginBottom: '0.4em',
    borderBottom: '0.07em solid #FFFFFF',
    '@media (max-width: 1024px)': {
      fontSize: '7em',
    },
    '@media (max-width: 480px)': {
      fontSize: '15vw',
      margin: '20px',
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
  },
  description: {
    fontWeight: 400,
    margin: 0,
    padding: 30,
    fontSize: '2.8em',
    '@media (max-width: 1024px)': {
      width: '70%',
      textAlign: 'center',
    },
    '@media (max-width: 480px)': {
      margin: '0 50px 0 50px',
      fontSize: '1em',
    },
  },
  button: {
    height: '4em',
    cursor: 'pointer',
    '@media (max-width: 480px)': {
      height: '45px',
    },
  },
  logo: {
    position: 'absolute',
    zIndex: 10,
    paddingLeft: 20,
    paddingTop: 20,
  },
})

function Landscape() {
  const { t } = useTranslation('translation')

  return (
    <>
      <UILogo dynamicStyle={styles.logo} logoWhite={true} />
      <div className={css(styles.container)}>
        <img
          src={backgroundImage}
          className={css(styles.backgroundImage)}
          alt="background image"
          width="100%"
          height="100%"
        />
        <div className={css(styles.content)}>
          <p className={css(styles.description)}>
            {t('pages.notFound.description')}
          </p>
        </div>
      </div>
    </>
  )
}

export default Landscape
